import { useState, SyntheticEvent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useModal } from 'mui-modal-provider';
import { useReactiveVar } from '@apollo/client';

import { useStyles } from './tabs-content.styles';
import { Button } from '../../../../common/button-new';
import { TabPanel } from '../../../../common/tab-panel';
import { NoPlayStore } from '../no-play-store';
import qrCode from '../../../../../assets/images/qr-code-eye.svg';
import appStore from '../../../../../assets/images/mobile-markets/app-store.svg';
import playStore from '../../../../../assets/images/mobile-markets/google-play.svg';
import ruStore from '../../../../../assets/images/mobile-markets/ru-store.svg';
import {
  APP_STORE_LINK_TEST_ID,
  ExternalLinks,
  GOOGLE_PLAY_LINK_TEST_ID,
  RU_STORE_LINK_TEST_ID,
} from '../../../../../constants';
import { setIsRuStore } from '../../../../../graphql/configuration/configuration.cache';
import mapBanner from '../../../../../assets/images/banner-map.png';

interface ILinksProps {
  icon: string;
  additionalIcon?: string | null;
  additionalPlatform?: string | null;
  platform: string;
  onNoPlayStoreClick: () => void;
}

const Links = ({ icon, additionalIcon, additionalPlatform, platform, onNoPlayStoreClick }: ILinksProps) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <a
        target="_blank"
        className={classes.link}
        href={ExternalLinks.mobileMarket}
        aria-label={intl.formatMessage(
          { id: 'downloadApp.link' },
          { platform },
        )}
        data-testid={platform === 'iOS' ? APP_STORE_LINK_TEST_ID : GOOGLE_PLAY_LINK_TEST_ID}
      >
        <img src={icon} alt="" />
      </a>
      {(additionalPlatform && additionalIcon) && (
        <a
          target="_blank"
          className={classes.link}
          href={ExternalLinks.ruStore}
          aria-label={intl.formatMessage(
            { id: 'downloadApp.link' },
            { platform },
          )}
          data-testid={RU_STORE_LINK_TEST_ID}
        >
          <img src={additionalIcon} alt="" />
        </a>
      )}
      <Button style="text" onClick={onNoPlayStoreClick} isUnderline textClasses={classes.text}>
        <FormattedMessage id="downloadApp.no-play-store" />
      </Button>
    </>
  );
};

export const TabsContent = () => {
  const [value, setValue] = useState(0);
  const isRuStore = useReactiveVar(setIsRuStore);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const classes = useStyles();
  const intl = useIntl();

  function a11yProps(index: number) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  const panels = [
    {
      icon: playStore,
      platform: 'Android',
      additionalPlatform: isRuStore ? 'ruStore' : null,
      additionalIcon: isRuStore ? ruStore : null,
    },
    {
      icon: appStore,
      platform: 'iOS',
    },
  ];

  const { showModal } = useModal();

  const handleNoPlayStoreClick = () => {
    showModal(NoPlayStore, {});
  };

  return (
    <div className={classes.root}>
      <div className={classes.tabsWrapper}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label={intl.formatMessage({ id: 'downloadApp.button.android' })} {...a11yProps(1)} />
          <Tab label={intl.formatMessage({ id: 'downloadApp.button.ios' })} {...a11yProps(2)} />
        </Tabs>
      </div>
      {panels.map((panel, index) => (
        <TabPanel value={value} index={index} key={index}>
          <div className={classes.panelInner}>
            <div className={classes.content}>
              <div className={classes.topRowBanner}>
                <div className={classes.qrCode}>
                  <img src={qrCode} alt={intl.formatMessage({ id: 'common.qrCode' })} />
                </div>
                <div className={classes.linksColumn}>
                  <Links
                    icon={panel.icon}
                    additionalIcon={panel.additionalIcon}
                    additionalPlatform={panel.additionalPlatform}
                    platform={panel.platform}
                    onNoPlayStoreClick={handleNoPlayStoreClick}
                  />
                </div>
              </div>
            </div>
             <div className={classes.bannerContainer}>
                <img className={classes.imageBanner} src={mapBanner} alt="" />
             </div>
          </div>
        </TabPanel>
      ))}
    </div>
  );
};
